import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PageBase } from 'src/core-lib/navigation/base-page';
import { Page } from 'src/core-lib/navigation/models/page.interface';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { BreadcrumbsModule } from 'src/layout/breadcrumbs/breadcrumbs.module';
import { GridModule } from 'src/layout/grid/grid.module';
import { UmbracoGrid } from 'src/layout/grid/models/umbraco-grid.type';
import { MediaModule } from 'src/layout/media/media.module';


export interface ArticlePage extends Page {
    media?: UmbracoImage | string;
    tag?: string;
    layoutLabel?: string;
    layout?: UmbracoGrid;
    prelayout?: UmbracoGrid;
    url?: string;
    updated?: string;
}


@Component({
    selector: 'app-article-page',
    templateUrl: './article-page.component.html',
    styleUrls: ['./article-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        NavigationModule,
        BreadcrumbsModule,
        GridModule,
        MediaModule,
        NavigationModule,
        TranslateModule,
    ],
    standalone: true,
})
export class ArticlePageComponent extends PageBase {
    page: ArticlePage;
}
